import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  messages: [],
  typingUsers: {}
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    addMessage: (state, action) => {
      state.messages.push(action.payload);
    },
    editMessage: (state, action) => {
      const msg = state.messages.find(m => m.messageId === action.payload.messageId);
      if (msg) {
        msg.content = action.payload.content;
        msg.isEdited = true;
      }
    },
    deleteMessage: (state, action) => {
      state.messages = state.messages.filter(m => m.messageId !== action.payload.messageId);
    },
    addReply: (state, action) => {
      const reply = action.payload;
      state.messages.push(reply);
    },
    updateReactions: (state, action) => {
      const { messageId, reactions } = action.payload;
      const msg = state.messages.find(m => m.messageId === messageId);
      if (msg) {
        msg.reactions = reactions;
      }
    },
    setTyping: (state, action) => {
      const { userId, isTyping, profile } = action.payload;
      state.typingUsers[userId] = { isTyping, profile };
    },
    clearTyping: (state, action) => {
      delete state.typingUsers[action.payload.userId];
    }
  }
});

export const {
  addMessage,
  editMessage,
  deleteMessage,
  addReply,
  updateReactions,
  setTyping,
  clearTyping
} = chatSlice.actions;

export default chatSlice.reducer;
